
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuLittlePoolCoffeeLittlePoolCoffeeImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/little_pool_coffee",
  title: "【2時間待ち】原宿のリトルプールコーヒーのオムライスが最高だった",
  description: "原宿のオムライスの人気店「リトルプールコーヒー」についてご紹介します。営業時間、お店の外観、メニュー、隠れメニュー、行列情報を写真付きでご紹介させていただきます。お店の外観やメニューについては、写真付きでご紹介。行列情報は、複数のデータと実体験をベースにして作成しているので、実際にお越しの際にも役立つ情報になっているのではないかと思います。",
  topImg: harajukuLittlePoolCoffeeLittlePoolCoffeeImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "カフェ", "オムライス", "落ち着いた雰囲気"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿のオムライスの人気店「リトルプールコーヒー」についてご紹介します。`}</p>
    <p>{`営業時間、お店の外観、メニュー、隠れメニュー、行列情報を写真付きでご紹介させていただきます。`}</p>
    <p>{`オムライスは食べられる時間が決まっていたり、2 種類から選択することができたり、隠れメニューがあったりするので、ぜひチェックしてみてください！行列情報は、複数のデータと実体験をベースにして作成しているので、実際にお越しの際にも役立つ情報になっているのではないかと思います。`}</p>
    <h2>{`リトルプールコーヒーとは`}</h2>
    <InstaImage postId="B-BEmlBhFvI" mdxType="InstaImage" />
    <p>{`原宿から徒歩 10 分の距離に位置するカフェで、バリスタが作るコーヒーはもちろんのこと、それよりもオムライスがが美味しいお店として人気で、連日行列ができるほど。`}</p>
    <p>{`オムライスはいつでも食べられるわけではなく、`}<strong parentName="p">{`11:30 ～ 16:30 `}</strong>{`の時間帯限定なので、そのオムライスのランチをインスタや口コミなどで見た女性のお客様が多数来店されているそうです。`}</p>
    <p>{`また、水曜日は定休日なので、お店に行く際にはくれぐれも曜日と時間を確認してください。`}</p>
    <h3>{`お店の外観`}</h3>
    <InstaImage postId="B_MmBqKAp1o" mdxType="InstaImage" />
    <h3>{`テラス席を完備`}</h3>
    <p>{`リトルプールコーヒーではテラス席を完備しているので、天気が良い日には店内やテイクアウトだけではなく、テラス席でオムライスのランチを食べるのもオススメです。`}</p>
    <h3>{`オムライスの看板`}</h3>
    <InstaImage postId="CBu4wwQAuFN" mdxType="InstaImage" />
    <p>{`お店の外観には、「美味しいオムライスあります」という緑色の旗があるのが特徴的です。
カフェなのにオムライスが推しのお店というのは斬新で面白いですよね。`}</p>
    <h2>{`ふわとろのオムライス`}</h2>
    <p>{`リトルプールコーヒーでは、2 種類のオムライスを選ぶことができます。`}</p>
    <InstaImage postId="CB3Af6sno6Z" mdxType="InstaImage" />
    <p>{`写真の左側のオムライスがふわふわで、右側がとろとろのオムライスです。
値段はそれぞれ一緒なのですが、見た目と食感が少し違うので、それぞれ一つずつ見ていきましょう。`}</p>
    <h3>{`ふわふわオムライス`}</h3>
    <InstaImage postId="B-q92AXh9V2" mdxType="InstaImage" />
    <p>{`卵の表面に焦げ目が一切なく、きめ細やかな表面から光沢を感じるような芸術的な美しさ。
スプーンを入れるとふわっとした食感があり、食べた時にも驚くほどふわっとしています。`}</p>
    <p>{`味付けは、ケチャップライスが薄味で、ケチャップソースがしっかり酸味が効いて刺激的な味付けになっています。`}</p>
    <h3>{`とろとろオムライス`}</h3>
    <p>{`とろとろオムライスは、卵の中が半熟になっており、卵を割るととろとろの卵が溢れてきます。
半熟の卵とケチャップの刺激的な酸味が混じり合い、優しい味わいのオムライスに仕上がっています。`}</p>
    <h3>{`オプションでオムライスの楽しみが倍増`}</h3>
    <InstaImage postId="CAaW6vtgeNg" mdxType="InstaImage" />
    <p>{`オプションでご飯の大盛り、チーズトッピング、ドリンクセットなどのメニューが用意されています。
その日の気分に合わせて、友達やカップルで相談しながら、その日にどんなオムライスを食べるのか相談して決めてみるのがオススメです！`}</p>
    <h4>{`限定のトリュフオムライス！？`}</h4>
    <p>{`隠れメニューの 1 つ「トリュフオムライス」が、不定期かつ限定で販売されるそうです。
チーズオムライスにトリュフオイルをかけて食べられるオムライスなので、お越しの際にはぜひお店の方に尋ねてみてください。`}</p>
    <h3>{`ドリンクセット`}</h3>
    <InstaImage postId="CCIoKpFjfGA" mdxType="InstaImage" />
    <p>{`バリスタがいるお店なので、コーヒーも煎れたての美味しいコーヒーを楽しむことができます。
また、酵素ジュースもメニューとして提供しているので、消化や代謝を促しアンチエイジング効果が期待できる酵素ジュースで胃腸の調子を整えるのもオススメです。`}</p>
    <h2>{`行列情報`}</h2>
    <p>{`平日、休日問わず、長い時には 2 時間以上も待ち時間ができることもあるみたいです。
しかも、そのほとんどが女性客ということから、SNS や口コミなどで拡散されております。`}</p>
    <p>{`テイクアウトも店内も待ちの列は同じなので、ランチタイムの時間帯だと 1 時間待ちは覚悟しないといけないですね。
どうしても並びたくないという方は、Uber Eats でデリバリーを始めたので、そちらで注文する選択肢もありかもしれません。`}</p>
    <h3>{`おわりに`}</h3>
    <p>{`原宿の人気のオムライスのランチが食べられる「リトルプールコーヒー」についてご紹介せていただきましたが、いかがでしたでしょうか。
写真で見てもわかるふわふわ、ぷるぷる、とろとろ感を、ぜひ直接お店に行って堪能してみてください！`}</p>
    <ShopInfoBox shopId="bs0mg5a23akg0088jl4g" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;